// src/pages/driver/driverJobList/FutileModal.jsx — confirmation modal for marking a stop futile
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FUTILE_CHARGE_AMOUNT } from "./helpers";

export default function FutileModal({ open, target, onCancel, onConfirm }) {
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) setNote("");
  }, [open, target?.runKey, target?.idx]);

  if (!open || !target) return null;

  const canConfirm = note.trim().length > 0;

  const modal = (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md border border-gray-200">
        <div className="border-b border-gray-200 px-4 py-3">
          <h3 className="text-base font-semibold text-gray-900">FUTILE stop</h3>
        </div>
        <div className="p-4 space-y-3 text-sm">
          <p className="text-gray-700">
            Mark this stop as futile:
            <span className="font-semibold">
              {" "}
              {target?.addr?.address || "Address"}
            </span>
          </p>

          <div className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-medium text-amber-900">
            A futile charge of ${FUTILE_CHARGE_AMOUNT} will be added for this stop.
          </div>

          <div>
            <label className="block text-xs font-medium text-gray-700 mb-1">
              Futile note (required)
            </label>
            <textarea
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm min-h-[100px] focus:outline-none focus:ring-1 focus:ring-red-400 focus:border-red-400"
              placeholder="Explain why the stop was futiled, e.g. no access, locked gate, unsafe entry..."
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>
        <div className="border-t border-gray-200 px-4 py-3 flex gap-2 justify-end">
          <button
            className="px-4 py-2 rounded-lg bg-white border border-gray-300 text-sm font-medium text-gray-700 hover:bg-gray-50 transition"
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className={`px-4 py-2 rounded-lg text-sm font-medium text-white transition ${
              canConfirm
                ? "bg-red-600 hover:bg-red-700"
                : "bg-gray-300 cursor-not-allowed"
            }`}
            disabled={!canConfirm}
            onClick={() => canConfirm && onConfirm({ note: note.trim() })}
          >
            Confirm FUTILE
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
